import { IResourceComponentsProps, useNavigation } from "@refinedev/core";
import { Create, useForm } from "@refinedev/antd";
import { Form } from "antd";

import { FormList } from "./form";
import { IApiKey } from "interfaces";
import { dataProvider } from "dataProvider";

export const ApiKeyCreate: React.FC<IResourceComponentsProps> = () => {
  const { list } = useNavigation();

  const { formProps, saveButtonProps, queryResult } = useForm<IApiKey>({
    warnWhenUnsavedChanges: false,
  });

  const addApiKey = async (variables: any) => {
    await dataProvider.create({
      resource: "keys",
      variables,
      metadata: undefined,
    });

    list("keys");
  };

  return (
    <Create
      isLoading={queryResult?.isFetching}
      saveButtonProps={saveButtonProps}
    >
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => addApiKey(values)}
      >
        <FormList formProps={formProps} type="create" />
      </Form>
    </Create>
  );
};
